@if (table().rows.length === 0 && table().issues.length === 0 && !editable()) {
  <p class="text-sm text-fq-text-2">Nessun campo VLAN compilato.</p>
} @else {
  <div class="grid gap-3" data-testid="vlan-table">
    <div class="flex flex-wrap items-center gap-2">
      @if (showTitle()) {
        <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">VLAN</span>
        @if (code()) {
          <span class="text-xs text-fq-text-muted">{{ code() }}</span>
        }
      }
      <div class="ml-auto flex flex-wrap items-center gap-1.5">
        @if (!editing()) {
          @if (table().complete) {
            <span class="fq-chip fq-chip-success px-2 py-0.5">
              <fa-icon [icon]="['fas', 'circle-check']" aria-hidden="true"></fa-icon>
              Nessuna anomalia
            </span>
          } @else {
            @if (statusCounts().error > 0) {
              <span class="fq-chip fq-chip-danger px-2 py-0.5">{{ statusCounts().error }} in errore</span>
            }
            @if (statusCounts().warning > 0) {
              <span class="fq-chip fq-chip-warning px-2 py-0.5">{{ statusCounts().warning }} {{ statusCounts().warning === 1 ? 'parziale' : 'parziali' }}</span>
            }
            @if (statusCounts().ok > 0) {
              <span class="fq-chip fq-chip-success px-2 py-0.5">{{ statusCounts().ok }} OK</span>
            }
          }
          @if (editable()) {
            <button type="button" class="fq-btn fq-btn-outline-primary fq-btn-sm" (click)="startEdit()">Modifica</button>
          }
        }
      </div>
    </div>

    @if (editing()) {
      <div class="flex flex-wrap items-center gap-2 rounded-lg border border-fq-border bg-fq-surface-subtle px-3 py-2">
        <span class="text-xs font-semibold text-fq-text-2">Modifica VLAN</span>
        <span class="text-xs text-fq-text-muted">Salva riscrive trunk, liste e descrizioni nel formato originale (max 255 caratteri per campo).</span>
        <div class="ml-auto flex flex-wrap items-center gap-2">
          <button type="button" class="fq-btn fq-btn-outline-primary fq-btn-sm" (click)="addRow()">Aggiungi VLAN</button>
          <button type="button" class="fq-btn fq-btn-secondary fq-btn-sm" (click)="cancelEdit()">Annulla</button>
          <button type="button" class="fq-btn fq-btn-primary fq-btn-sm" (click)="commitEdit()">Salva</button>
        </div>
      </div>

      @if (editErrors().length > 0) {
        <div class="fq-alert fq-alert-danger">
          <fa-icon class="fq-alert-icon" [icon]="['fas', 'circle-exclamation']" aria-hidden="true"></fa-icon>
          <div class="min-w-0">
            <div class="fq-alert-title">Impossibile salvare</div>
            <ul class="fq-alert-detail list-disc pl-4">
              @for (error of editErrors(); track $index) {
                <li>{{ error }}</li>
              }
            </ul>
          </div>
        </div>
      }
    }

    @if (!editing() && table().issues.length > 0) {
      <div class="fq-alert" [ngClass]="'fq-alert-' + alertTone()">
        <fa-icon class="fq-alert-icon" [icon]="['fas', 'circle-exclamation']" aria-hidden="true"></fa-icon>
        <div class="min-w-0">
          <div class="fq-alert-title">Campi VLAN da verificare</div>
          <ul class="fq-alert-detail list-disc pl-4">
            @for (issue of table().issues; track $index) {
              <li>{{ issue.message }}</li>
            }
          </ul>
        </div>
      </div>
    }

    <div class="overflow-x-auto">
      <table class="w-full table-fixed text-left text-xs">
        <thead>
          <tr class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">
            <th class="w-[9rem] pb-1.5 pr-3 font-bold">VLAN</th>
            <th class="w-[9.5rem] pb-1.5 pr-3 font-bold">Network</th>
            <th class="pb-1.5 pr-3 font-bold">Descrizione</th>
            <th class="w-[7rem] pb-1.5 text-right font-bold">{{ editing() ? 'Azioni' : 'Stato' }}</th>
          </tr>
        </thead>
        <tbody>
          @if (editing()) {
            @for (row of draft(); track $index) {
              <tr class="border-t border-fq-border-faint odd:bg-fq-surface-subtle">
                <td class="py-1.5 pr-3 align-top">
                  <input pInputText pSize="small" class="w-full text-xs" inputmode="numeric" autocomplete="off" placeholder="VLAN"
                    [ngModel]="row.vlanId" (ngModelChange)="updateDraft($index, 'vlanId', $event)"
                    [ngModelOptions]="{ standalone: true }" />
                </td>
                <td class="py-1.5 pr-3 align-top">
                  <input pInputText pSize="small" class="w-full font-mono text-xs" autocomplete="off" placeholder="10.0.0.0/24"
                    [ngModel]="row.network" (ngModelChange)="updateDraft($index, 'network', $event)"
                    [ngModelOptions]="{ standalone: true }" />
                </td>
                <td class="py-1.5 pr-3 align-top">
                  <input pInputText pSize="small" class="w-full text-xs" autocomplete="off" placeholder="Descrizione"
                    [ngModel]="row.description" (ngModelChange)="updateDraft($index, 'description', $event)"
                    [ngModelOptions]="{ standalone: true }" />
                </td>
                <td class="py-1.5 text-right align-top">
                  <button type="button" class="fq-btn fq-btn-outline-danger fq-btn-sm fq-btn-icon"
                    (click)="removeRow($index)" aria-label="Rimuovi VLAN" title="Rimuovi VLAN">
                    <fa-icon [icon]="['fas', 'trash']" aria-hidden="true"></fa-icon>
                  </button>
                </td>
              </tr>
            }
          } @else {
            @for (row of table().rows; track row.vlanId) {
              <tr class="border-t border-fq-border-faint odd:bg-fq-surface-subtle transition-colors hover:bg-fq-primary/5">
                <td class="py-1.5 pr-3 align-top">
                  <div class="flex flex-wrap items-center gap-1.5">
                    <span class="font-semibold tabular-nums text-fq-text-2">{{ row.vlanId }}</span>
                    @if (!row.inTrunk) {
                      <span class="fq-chip fq-chip-danger px-2 py-0.5">non in trunk</span>
                    }
                  </div>
                </td>
                <td class="py-1.5 pr-3 align-top font-mono tabular-nums">
                  @if (row.network) {
                    <span class="text-fq-text-2">{{ row.network }}</span>
                  } @else {
                    <span class="font-sans font-semibold text-fq-danger">mancante</span>
                  }
                </td>
                <td class="break-words py-1.5 pr-3 align-top">
                  @if (row.description) {
                    <span class="text-fq-text-2">{{ row.description }}</span>
                  } @else {
                    <span class="text-fq-warning">mancante</span>
                  }
                </td>
                <td class="py-1.5 text-right align-top">
                  <span class="fq-chip px-2 py-0.5" [ngClass]="statusClass(row.status)"
                    [pTooltip]="issuesText(row)" [tooltipDisabled]="row.issues.length === 0"
                    tooltipPosition="top" appendTo="body">{{ statusLabel(row.status) }}</span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    @if (showRaw() && !editing()) {
      <details class="group">
        <summary class="flex cursor-pointer select-none items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">
          <fa-icon [icon]="['fas', 'chevron-right']" class="transition-transform group-open:rotate-90" aria-hidden="true"></fa-icon>
          Valori originali
        </summary>
        <div class="mt-2 grid gap-2 md:grid-cols-2">
          @for (check of rawChecks(); track check.field) {
            <div class="rounded-lg border border-fq-border-faint bg-fq-surface-subtle p-2.5">
              <div class="flex flex-wrap items-center gap-2">
                <fa-icon [icon]="check.valid ? ['fas', 'circle-check'] : ['fas', 'circle-exclamation']"
                  [class]="check.valid ? 'fq-success-color' : 'fq-danger-color'" aria-hidden="true"></fa-icon>
                <span class="text-xs font-semibold text-fq-text">{{ fieldLabel(check.field) }}</span>
                <span class="fq-badge ml-auto" [ngClass]="check.valid ? 'fq-badge-success' : 'fq-badge-danger'">{{ check.valid ? 'OK' : 'KO' }}</span>
              </div>
              <div class="mt-1 truncate font-mono text-[11px] text-fq-text-muted" [pTooltip]="check.value" tooltipPosition="top" appendTo="body">{{ check.value || '—' }}</div>
              @if (!check.valid) {
                <div class="mt-1 text-xs text-fq-danger">{{ check.message }}</div>
              }
            </div>
          }
        </div>
      </details>
    }
  </div>
}
